import { motion } from "framer-motion";
import { EyeOff, FileCheck, Users, Compass } from "lucide-react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import ApplyCta from "./ApplyCta";
const painPoints = [{
  icon: EyeOff,
  title: "El Impuesto a la Invisibilidad",
  description: "Tu silencio financia el crecimiento de tu competencia. Si sos el referente pero no lo comunicás, sos el secreto mejor guardado de tu industria."
}, {
  icon: FileCheck,
  title: "La Brecha de Percepción",
  description: "Tu imagen actual es un traje que ya te queda chico. Te perciben por lo que eras, no por la magnitud de lo que sos hoy."
}, {
  icon: Users,
  title: 'El Techo del "Boca en Boca"',
  description: "La recomendación te trajo hasta acá, pero ya no es suficiente. Estás perdiendo territorio frente a competidores que, con menos trayectoria, tienen más alcance."
}, {
  icon: Compass,
  title: "El Vacío de Dirección",
  description: "Tu empresa escaló, pero tu comunicación se quedó atrás. Sin una dirección estratégica alineada a tu visión, el crecimiento corre peligro."
}];
const Challenge = () => {
  return <section className="py-24 md:py-32 relative overflow-hidden bg-background" id="desafio">
      <div className="container px-4">
        {/* Section header */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center max-w-4xl mx-auto mb-12">
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Tu marca ya tiene trayectoria.{" "}
            <span className="text-gradient-gold">Pero le falta activar su autoridad</span>
          </h2>
        </motion.div>

        {/* Intro text */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-center text-lg text-muted-foreground max-w-3xl mx-auto mb-16">
          Liderás una empresa sólida con resultados reales. Sin embargo, el mercado te juzga por lo que proyectás y tu imagen hoy está desactualizada. Estás pagando costos altísimos:
        </motion.p>

        {/* Pain points accordion */}
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.3 }} className="max-w-3xl mx-auto mb-16">
          <Accordion type="single" collapsible className="space-y-4">
            {painPoints.map((point, index) => (
              <AccordionItem key={point.title} value={`item-${index}`} className="bg-card rounded-2xl border border-border hover:border-primary/30 transition-all duration-300 px-8 py-2 data-[state=open]:shadow-lg">
                <AccordionTrigger className="hover:no-underline gap-5">
                  <div className="flex items-center gap-5">
                    <div className="w-14 h-14 rounded-full bg-[#7ab7fd] flex items-center justify-center flex-shrink-0">
                      <point.icon className="w-6 h-6 text-[#0a162a]" />
                    </div>
                    <h3 className="font-display text-xl font-semibold text-muted-foreground text-left">
                      {point.title}
                    </h3>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="pl-[4.75rem]">
                  <p className="leading-relaxed text-charcoal-dark text-base">
                    {point.description}
                  </p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>

        <ApplyCta />
      </div>
    </section>;
};
export default Challenge;